import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgClass } from '@angular/common';
import { IconComponent } from '../../../../shared/components/icon/icon.component';
import { DashboardPeriodFilterComponent } from '../dashboard-period-filter/dashboard-period-filter.component';
import { DashboardProgressBarComponent } from '../dashboard-progress-bar/dashboard-progress-bar.component';
import { DashboardPeriodOption, RankingItem } from '../../../../shared/models/interfaces/dashboard/dashboard.interface';

@Component({
  selector: 'l-dashboard-ranking-list',
  standalone: true,
  imports: [NgClass, IconComponent, DashboardPeriodFilterComponent, DashboardProgressBarComponent],
  templateUrl: './dashboard-ranking-list.component.html',
})
export class DashboardRankingListComponent {

  @Input({ required: true })
  public title: string = '';

  @Input()
  public subtitle: string = '';

  @Input({ required: true })
  public items: RankingItem[] = [];

  @Input({ required: true })
  public valueColumnLabel: string = '';

  @Input()
  public nameColumnLabel: string = 'Curso';

  @Input()
  public showProgressBars: boolean = true;

  @Input()
  public showFilter: boolean = true;

  @Input()
  public variant: 'lessons' | 'courses' = 'courses';

  @Input()
  public periodOptions: DashboardPeriodOption[] = [];

  @Input()
  public selectedPeriod: string = '';

  @Output()
  public readonly selectedPeriodChange = new EventEmitter<string>();

  public getBarValue(item: RankingItem): number {
    return item.value;
  }

  public getBarMax(item: RankingItem): number {
    return item.isPercentage ? 100 : item.maxValue;
  }

  public formatValue(item: RankingItem): string {
    return item.isPercentage ? `${item.value}%` : String(item.value);
  }

}
